module.exports = __webpack_public_path__ + "static/4-36bb67aa7689b1842a662908f32d50ca.jpg";